/* Angular */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';
import { DatePipe } from '@angular/common';

/* Store */
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { reducers, effects, metaReducers, CustomSerializer, ExcelService } from '@app/core';

/* Rich text Editor */
import { NgxWigModule } from 'ngx-wig';

/* Components */
import { AppComponent } from './app.component';


/* Application Modules */
import { CoreModule, ServiceLocator } from '@app/core';
import { environment } from '../environments/environment';

import {
  SharedModule,
  DialogService,
  NotificationService
} from '@app/shared';

import { DashboardModule } from './dashboard/dashboard.module';

/* Services */

/* Routing */
import { AppRoutingModule } from './app.routing.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    /* Application Modules */
    CoreModule,
    SharedModule,

    AppRoutingModule,

    /* Store */
    //StoreModule.forRoot(reducers, { metaReducers}),
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule,

    /*Rich text Editor*/
    NgxWigModule,

    // Instrumentation must be imported after importing StoreModule (config is optional)
    !environment.production ?
      StoreDevtoolsModule.instrument({
        maxAge: 25 // Retains last 25 states
      })
      : [],

    
  ],
  providers: [
    DialogService,
    NotificationService,
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer
    },
    ExcelService,
    DatePipe
  ],
 
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    ServiceLocator.injector = this.injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts